
import Image from 'next/image'
import React from 'react'

import { useDispatch } from 'react-redux';
import { addToCart } from '../../redux/cartSlice';
import { v4 as uuidv4 } from "uuid";
import toast from 'react-hot-toast';
import ImageGallery from './ImageGallery';
import Divider from '../../components/common/Divider'

function Section7({ noHeadingText }) {

	const cards = [
		// {
		// 	name: "Tangem Card (Black Edition)",
		// 	price: 45,
		// 	description: "",
		// 	type: 'card',
		// 	value: "tangem-card-black"
		// },
		// {
		// 	name: "Tangem Card (White Edition)",
		// 	price: 45,
		// 	description: "",
		// 	type: 'card',
		// 	value: "tangem-card-white"

		// },
		{
			name: "Tangem Card (Pack of 2)",
			price: 54.90,
			description: "",
			type: 'card',
			value: "tangem-card-bundle"

		},
		{
			name: "Tron Card",
			price: 30,
			description: "",
			type: 'card',
			value: "tron-Card"
		},
	];

	const dispatch = useDispatch();

	// const [selectedCard, setSelectedCard] = React.useState('tangem-card-black');

	// function handleChange(e) {
	// 	setSelectedCard(e.target.value)
	// }

	const [quantity, setQuantity] = React.useState(1);
	const cardsSetPrice = 54.90

	function addCardToCart() {
		toast.success("Added to Cart!")
		// const card = cards.find(item => item.value === selectedCard)
		dispatch(addToCart({
			fullname: "Tangem Card (Pack of 2)",
			tld: "card",
			price: cardsSetPrice,
			description: "",
			type: 'card',
			quantity, type: "card", id: "tangem-card"
		}))

	}
	const gm = [
		// {
		// 	video: "/scan.webm",
		// 	videoImg: '/images/wallet-page/video-placolder.png'
		// },
		{
			img: "/images/wallet-page/tangem-1.jpeg"
		},
		{
			img: "/images/wallet-page/tangem-3.jpeg"
		},
		{
			img: "/images/wallet-page/tangem-2.jpeg"
		},
		{
			img: "/images/wallet-page/tangem-4.jpeg"
		},
		{
			img: "/images/wallet-page/tangem-5.jpeg"
		},
	]

	function handleAdd() {
		setQuantity(quantity + 1)
	}


	function handleMinus() {
		if (quantity !== 1) {
			setQuantity(quantity - 1)
		}
	}

	return (
		<div className={` ${!noHeadingText ? "container " : ""}`}>
			<div className={!noHeadingText ? 'border-2 border-gray-300 dark:border-gray-200 relative rounded-large py-8 px-8 md:px-12' : ""}>
				<div className='grid grid-cols-1 md:grid-cols-2 gap-6 '>
					<div>
						<ImageGallery galleryImages={gm} />
					</div>
					<div>
						{/* <div>

							<div className='border-gray-300 dark:border-gray-200 border-2  px-6 py-[50px] rounded-[10px]'>
								<p className='text-2xl font-bold text-jacarta-900 dark:text-white  mb-4'>Choose your Preferred Card</p>
								<p className='text-base text-gray-400 mb-2'>Some Text here</p>
								<p className='text-[2.5rem] font-bold dark:text-white text-jacarta-900 mb-2'>$45.00 USD</p>
								<select value={selectedCard} onChange={handleChange} className="dark:bg-jacarta-900 border-gray-300 dark:border-jacarta-600  mr-8 min-w-[12rem] w-full rounded-lg py-3.5 text-sm dark:text-white">

									<option value="tangem-card-bundle">Tangem Card (Pack of 2) $120</option>
									<option value="tron-Card">Tron Card $30</option>
								</select>
								<button onClick={() => addCardToCart()} className=" mt-4 items-center  justify-center rounded-md text-[18px] font-medium  bg-gradient-to-tr from-hotPink via-purplish to-accent py-[18px] px-[32px] md:py-[14px] md:px-[38px] w-full cursor-pointer button z-[2] transition-all duration-500 text-white hover:-translate-y-1 text-center" >Buy Now</button>
							</div>
						</div> */}


						<div className=" dark:text-white  mx-auto">
							<h1 className="text-3xl font-bold mb-2">Choose your Tangem Cards</h1>
							<div className="mb-6">
								<h2 className="font-semibold mb-2">Choose your option</h2>
								<div className="space-y-2">
									<div className="bg-jacarta-500 dark:bg-jacarta-700 p-4 rounded-lg  relative">
										<input type='checkbox' className="hidden peer" id='tangem-card-bundle' />
										<label className="text-white flex justify-between items-center">
											<div>
												<p className=" text-lg font-semibold">2 Cards set / one Wallet</p>
											</div>
											<p className="text-lg font-semibold">$54.90</p>
										</label>
									</div>
								</div>
							</div>
							<div className="flex items-center justify-center mb-6">
								<p className='dark:text-white text-jacarta-900 text-md font-medium mr-2'>Quantity</p>
								<div className="flex items-center gap-2">
									<button className="bg-jacarta-700 text-white px-4 py-2 font-bold text-xl rounded-md" onClick={handleMinus}>-</button>
									<div className='bg-jacarta-700 text-white px-4 py-2'>
										{quantity}
									</div>
									<button className="bg-jacarta-700 text-white px-4 py-2 font-bold text-xl rounded-md" onClick={handleAdd}>+</button>
								</div>

							</div>
							<Divider />
							<div className=" pt-4">
								<div className="flex justify-between items-center mb-4">
									<h2 className="text-2xl font-bold">Total</h2>
									<p className="text-2xl font-bold">${parseFloat(cardsSetPrice * quantity).toFixed(2)}</p>
								</div>
								<button onClick={() => addCardToCart()} className=" mt-4 items-center  justify-center rounded-md text-[18px] font-medium  bg-gradient-to-tr from-hotPink via-purplish to-accent py-[18px] px-[32px] md:py-[14px] md:px-[38px] w-full cursor-pointer button z-[2] transition-all duration-500 text-white hover:-translate-y-1 text-center" >Buy Now</button>
							</div>
						</div>

					</div>
				</div>
				<div className={`flex items-center justify-center gap-16 mt-10 ${noHeadingText && '!hidden'}`}>
					<div className="flex flex-col items-center">
						<div className="mb-2 text-sm md:text-lg dark:text-gray-200 text-jacarta-900 font-medium">App Store</div>
						<Image width={123} height={60} src='/images/google-mobile.png' alt='google-mobile' />
						<p className="mt-2 text-sm md:text-lg dark:text-gray-200 text-jacarta-900 font-medium text-center">Worldwide average score</p>
						<div className="flex items-center justify-center gap-2 mt-2 text-sm md:text-lg font-semibold">
							4.9
							<Image width={20} height={20} src='/images/star.png' alt='star' />
						</div>
					</div>
					<div className="flex flex-col items-center ">
						<div className="mb-2 text-sm md:text-lg dark:text-gray-200 text-jacarta-900 font-medium">Google Play</div>
						<Image width={123} height={60} src='/images/apple-mobile.png' alt='apple-mobile' />
						<p className="mt-2 text-sm md:text-lg dark:text-gray-200 text-jacarta-900 font-medium text-center">Worldwide average score</p>
						<div className="flex items-center justify-center gap-2 mt-2 text-sm md:text-lg font-semibold">
							5.0
							<Image width={20} height={20} src='/images/star.png' alt='star' />
						</div>
					</div>
				</div>
			</div>

		</div >
	)
}

export default Section7



